var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-container",
      class: "col-" + _vm.colSize + " " + _vm.wrapperClass,
    },
    [
      _vm.title
        ? _c("h6", { staticClass: "form-title mb-0" }, [
            _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "position-relative" }, [
        _c(
          "div",
          {
            staticClass: "form-group-material form-group-material-no-label",
            class: _vm.inputContainerClass,
          },
          [
            _c("input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: _vm.inputMask,
                  expression: "inputMask",
                },
              ],
              ref: "rawMaskInput",
              staticClass: "form material-input form-control",
              class: _vm.inputClass,
              attrs: {
                id: _vm.labelValue,
                type: _vm.type,
                placeholder: _vm.placeholder,
                disabled: _vm.disabled,
                readonly: _vm.readOnly,
                maxlength: _vm.maxlength,
              },
              domProps: { value: _vm.innerValue },
              on: {
                change: function (value) {
                  return (_vm.innerValue = value)
                },
                input: function (value) {
                  return (_vm.innerValue = value)
                },
              },
            }),
            _vm._v(" "),
            _vm.title
              ? _c(
                  "label",
                  { staticClass: "d-none", attrs: { for: _vm.labelValue } },
                  [_vm._v(_vm._s(_vm.title))]
                )
              : _c(
                  "label",
                  { staticClass: "d-none", attrs: { for: _vm.labelValue } },
                  [_vm._v(_vm._s(_vm.$t("custom-fields.fields.text.label")))]
                ),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.subtitle
        ? _c("h6", { staticClass: "form-title ml-2 font-sm mb-0" }, [
            _vm._v("\n    " + _vm._s(_vm.subtitle) + "\n  "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }